import React from "react";
import styled from "styled-components";
import Button from "../ui/Button";

const Container = styled.div``;

const Text = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.3;
  a {
    color: inherit;
  }
`;

const Price = styled.span`
  opacity: 0.8;
  display: inline-block;
  margin-left: 15px;
`;

const Checkbox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border: 2px solid ${(props) => props.color};
  background: white;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  min-width: 16px;
  svg {
    width: 12px !important;
    height: 12px !important;
    color: ${(props) => props.color};
    margin-left: 0 !important;
  }
`;

function AddFormzine1(props) {
  return (
    <Container>
      <Text>
        The first and second volumes of FORMZINE, compiled four and two years
        before this one respectively (February-March 2022 and 2024), are
        available to bundle with your FORMZINE Vol. 3 purchase in digital form
        only, each containing all 90+ pages of submitted work.
        <br />
        <br />
        All proceeds from sales of FORMZINE Vol. 1 go to{" "}
        <a href="https://rainn.org">RAINN</a>. All proceeds from sales of
        FORMZINE Vol. 2 go to <a href="https://pcrf.net">PCRF</a>.
      </Text>
      <br />
      <Button
        color={props.color}
        active={props.includeVol1}
        onClick={() => props.setIncludeVol1(!props.includeVol1)}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox color={props.color}>
            {props.includeVol1 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={4}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m4.5 12.75 6 6 9-13.5"
                />
              </svg>
            )}
          </Checkbox>
          Add FORMZINE Vol. 1 (digital only) <Price>$5</Price>
        </div>
      </Button>
      <br />
      <Button
        color={props.color}
        active={props.includeVol2}
        onClick={() => props.setIncludeVol2(!props.includeVol2)}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox color={props.color}>
            {props.includeVol2 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={4}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m4.5 12.75 6 6 9-13.5"
                />
              </svg>
            )}
          </Checkbox>
          Add FORMZINE Vol. 2 (digital only) <Price>$5</Price>
        </div>
      </Button>
    </Container>
  );
}

export default AddFormzine1;
